import { connect } from 'react-redux'
import { getActiveChallenges } from 'services/challenges'
import Navigation from 'support/navigation/index'
import AnalyticsService from 'support/analytics'
import View from './View'
import { getInnovateChallengeActiveTypes, getInnovateChallengeAllList, getInnovateChallengeFilterList } from 'services/innovate/challenge'


const mapStateToProps = state => {
  return {
    challengesAll: state.data.challenge.challenges,
    challengesFilter:state.data.challenge.challengesFilter,
    hasMoreChallengeToLoad:state.data.challenge.hasMore,
    challengeIdeasLoading: state.data.challenge.challengesLoading, 
    isAdmin: state.data.user.admin,
    isInnovator: state.data.user.isInnovator,
    localAdmin: state.data.user.localAdmin,
    enableIsHackathon: state.data.domain.config.globalIsHackthon,
    listInnovateChallenge:state.data.InnovateChallenge.listInnovateChallenge,
    listInnovateChallengeLoading:state.data.InnovateChallenge.listInnovateChallengeLoading,
    innovateCategoryTypes:state.data.InnovateChallenge.innovateCategoryTypes,
    innovateTypeLoading:state.data.InnovateChallenge.innovateTypeLoading,
    filterListInnovateChallengeTotal :state.data.InnovateChallenge.total,
    filterListInnovateChallenge:state.data.InnovateChallenge.filterListInnovateChallenge,
    filterListInnovateChallengeLoading:state.data.InnovateChallenge.filterListInnovateChallengeLoading,

    canProposeChallenge:
      !state.data.user.admin &&
      !state.data.user.isInnovator &&
      !state.data.user.localAdmin &&
      state.data.domain.domainConfiguration.challengeProposal,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getActiveChallenges: () => dispatch(getActiveChallenges()),
    // getFilteredChallenges: (status,isHackathon,limitValue,offset) => {
     getFilteredChallenges: (challengeStatus,offset,limitValue,isHackathon) => {
      // console.log("ch..",status,limitValue,offset)
     dispatch(getActiveChallenges(challengeStatus,offset,limitValue,isHackathon))
      AnalyticsService.trackEvent({
        category: 'swiper',
        action: 'click',
        label: 'apply new filter',
      })
    },
    navigateToChallengeDetail: id => dispatch(Navigation.navigateToChallengeDetail(id)),
    navigateToNewChallenge: () => dispatch(Navigation.navigateToChallengeNew()),
    navigateToExplore: () => dispatch(Navigation.navigateToExplore()),
    navigateToProposeChallenge: () => dispatch(Navigation.navigateToProposeChallenge()),
    navigateToNewIdea: challengeId => dispatch(Navigation.navigateToNewIdea(challengeId)),
    navigateToUserProfile: email => {
      dispatch(Navigation.navigateToUserProfile(email))
    },

     //innovate api call list

      getInnovateChallengeFilterListFn: (challengeStatus, offset,limit,enableIsHackathon) => {
        console.log("🚀 ~ mapDispatchToProps ~ challengeStatus:", challengeStatus)
        dispatch(getInnovateChallengeFilterList({challengeStatus,offset ,limit , enableIsHackathon}))

      },
    getInnovateChallengeAllListFn: () => {
      dispatch(getInnovateChallengeAllList())
    },
    getInnovateChallengeActiveTypesFn: () => {
      dispatch(getInnovateChallengeActiveTypes())
    },
    onEditClick: id => {
      dispatch(Navigation.navigateToInnovateChallengeForm(id))
    },
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View)
